import RpcApiClient from 'datasources/RpcApiClient'
import { useDispatch, useSelector } from 'react-redux'
import { appendSubstationsInfo, appendMunicipalityInfo, appendPlantsInfo } from 'store/global/map/finderInfo'
import moment from 'moment'

async function getMarketInteligenceTechnologyLayers(datastructure, token, client, plan, technology) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      technology: '',
      managements: datastructure.municipality.adminitrative_division,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.technology = technology
    const response = await RpcApiClient.getPowerplantsMarketInteligence(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getMarketInteligenceTranlineLayers(datastructure, token, client, plan, voltage) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      voltage: 0,
      managements: datastructure.municipality.adminitrative_division,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getTranlineMarketInteligence(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getMarketInteligenceSubstationsLayers(datastructure, token, client, plan, voltage) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      voltage: 0,
      managements: datastructure.municipality.adminitrative_division,
      voltages_needed: datastructure.infrastructure.substations,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getSubstationsMarketInteligence(token, requestBody)
    const data = await response
    return data.data.body
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getSaaviLayers(datastructure, token, client, plan, season, fill) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      season: season,
      filling: fill,
    }

    const response = await RpcApiClient.getSaaviLayers(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getSaaviLayersLMP(datastructure, token, client, plan, voltage, season) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      season: season,
      voltage: '',
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getSaaviLayersLMP(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getSaaviLayersCongestion(datastructure, token, client, plan, voltage, season) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      season: season,
      voltage: '',
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getSaaviLayersCongestion(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getLMP(datastructure, token, client, plan, voltage, firstDate, lastDate, timeLapse) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      firstDate: firstDate,
      lastDate: lastDate,
      timeLapse: timeLapse,
      voltage: '',
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getSaaviLayersLMP(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getTechnologyLayers(datastructure, token, client, plan, technology) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      technology: '',
      managements: datastructure.municipality.adminitrative_division,
      // managements: datastructure.managements ? datastructure.managements : [],
      // zones: datastructure.zones ? datastructure.zones : []
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.technology = technology
    const response = await RpcApiClient.getPowerplants(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getTranlineLayers(datastructure, token, client, plan, voltage) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      voltage: 0,
      managements: datastructure.municipality.adminitrative_division,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getTranline(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getProyectsUnderDevelopLayers(datastructure, token, client, plan, technology) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      technology: '',
      managements: datastructure.municipality.adminitrative_division,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.technology = technology
    const response = await RpcApiClient.getProjectsUnderDevelop(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getSubstationsLayers(datastructure, token, client, plan, voltage) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      voltage: 0,
      managements: datastructure.municipality.adminitrative_division,
      voltages_needed: datastructure.infrastructure.substations,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getSubstations(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getInterconnectionLayers(datastructure, token, client, plan, voltage, season) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      season: season,
      voltage: 0,
      managements: datastructure.municipality.adminitrative_division,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getInterconnection(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getTranlineConnectionLayers(datastructure, token, client, plan, voltage) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      voltage: 0,
      managements: datastructure.municipality.adminitrative_division,
    }

    if ('zones' in datastructure) {
      requestBody.zones = datastructure.zones
    }
    if ('countries' in datastructure) {
      requestBody.countries = datastructure.countries
    }

    requestBody.voltage = voltage
    const response = await RpcApiClient.getTranlineInterconnection(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getIndigenousLanguagesLayers(datastructure, token, client, plan) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      color_base: 'purple',
      color_variation: 'pink',
    }

    const response = await RpcApiClient.getIndigenousLanguages(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getArcheologyLayers(token, client, plan) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
    }

    const response = await RpcApiClient.getArcheology(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getOil_Gas(datastructure, token, client, plan, layer, type) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      type: type,
      countries: datastructure.countries,
    }

    if (layer === 'pipe') {
      const response = await RpcApiClient.getOilPipes(token, requestBody)
      const data = await response.data.body
      return data
    } else {
      const response = await RpcApiClient.getOilBasin(token, requestBody)
      const data = await response.data.body
      return data
    }
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

async function getMapboxLayers(datastructure, token, client, plan, tiles) {
  try {
    let requestBody = {
      clients: client,
      plans: plan,
      tiles: {},
      //country:datastructure.countries[0]
    }

    if ('countries' in datastructure) {
      requestBody.country = datastructure.countries[0]
    }

    requestBody.tiles = tiles
    const response = await RpcApiClient.getMapbox(token, requestBody)
    const data = await response.data.body
    return data
  } catch (err) {
    console.error(err.message)
    return { error: err.message }
  }
}

const getToolLayers = () => {
  return [
    {
      id: 'kml-layer-0',
      data: [],
      geotype: 'kml',
      layer: 'kml_layers',
      visible: true,
      design: {
        polygonColor: [235, 64, 52, 80],
        lineColor: [111, 255, 0],
        pointColor: [0, 132, 255],
        flag: [0, 0, 0],
      },
    },

    {
      id: 'kml-layer-1',
      data: [],
      geotype: 'kml',
      layer: 'kml_layers',
      visible: true,
      design: {
        polygonColor: [235, 64, 52, 80],
        lineColor: [111, 255, 0],
        pointColor: [0, 132, 255],
        flag: [0, 0, 0],
      },
    },

    {
      id: 'kml-layer-2',
      data: [],
      geotype: 'kml',
      layer: 'kml_layers',
      visible: true,
      design: {
        polygonColor: [235, 64, 52, 80],
        lineColor: [111, 255, 0],
        pointColor: [0, 132, 255],
        flag: [0, 0, 0],
      },
    },

    {
      id: 'kml-layer-3',
      data: [],
      geotype: 'kml',
      layer: 'kml_layers',
      visible: true,
      design: {
        polygonColor: [235, 64, 52, 80],
        lineColor: [111, 255, 0],
        pointColor: [0, 132, 255],
        flag: [0, 0, 0],
      },
    },

    {
      id: 'kml-layer-4',
      data: [],
      geotype: 'kml',
      layer: 'kml_layers',
      visible: true,
      design: {
        polygonColor: [235, 64, 52, 80],
        lineColor: [111, 255, 0],
        pointColor: [0, 132, 255],
        flag: [0, 0, 0],
      },
    },
  ]
}

export default class LayerFunctions {
  static async getDataStructure(datastructure, authData, setSideBarInfo, setSidebarData, setSidebarBandera) {
    const dispatch = useDispatch()
    const response = await RpcApiClient.getDataStructure(authData.jwtToken, datastructure)
    const data = await response.data.body

    dispatch(setSideBarInfo(data.data.data))
    let currentSidebarJSON = JSON.parse(JSON.stringify(data.data.data))
    let currentSidebar = [...currentSidebarJSON]
    setSidebarData(currentSidebar)
    setSidebarBandera(true)
  }

  static async getMunicipalityList(datastructure, token, client, plan) {
    let requestBody = {
      client: client,
      country: datastructure.countries,
    }

    const response = await RpcApiClient.getMunicipality(token, requestBody)
    const data = await response.data.body
    return data
  }

  static getList(list) {
    let data = []
    list.map((obj) => {
      data.push(obj.data)
    })
    return [].concat.apply([], data)
  }

  static async readLayers(sidebarData, sidebarBandera, client, layersInfo, datastructure, token, plan) {
    if (sidebarData.length && sidebarBandera && client) {
      if (!layersInfo.data.length) {
        let tiles = {
          protected_area: {
            protected_areas: [],
          },
          flor_fauna: {
            priority_regions: [],
          },
          social: {
            social: [],
            indigenous_presence_conabio: [],
          },
          land_ownership: {
            national_agricultural_registry: [],
            cadastre: [],
          },
          archeology: {},
          geology: {
            hydrology_regions: [],
            hydrology_basins: [],
            hydrology_sub_basins: [],
            geology: [],
            flood_zones: [],
          },
          municipality: {
            adminitrative_division: [],
          },
          oil_gas: {
            basin: [],
            hydrocarbon_contracts: [],
            pipelines: [],
            wells_seeps: [],
            roads: [],
          },
          land_use: {
            land_uses: [],
          },
        }

        const functions = []
        sidebarData.map((layers, index) => {
          switch (layers.title) {
            case 'Market Intelligence':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  layer.name == 'Power Plants'
                    ? functions.push(
                        getMarketInteligenceTechnologyLayers(datastructure, token, client, plan, value.value),
                      )
                    : layer.name == 'Transmission Lines'
                    ? functions.push(
                        getMarketInteligenceTranlineLayers(datastructure, token, client, plan, value.value),
                      )
                    : functions.push(
                        getMarketInteligenceSubstationsLayers(datastructure, token, client, plan, value.value),
                      )
                })
              })
              break

            case 'Local Marginal Prices':
              if (client != 'saavi') {
                const lastDate = moment(new Date()).format('YYYY-MM-01')
                layers.layers.map((layer) => {
                  let dates = Object.keys(layer[client])
                  dates.map((date) => {
                    layer[client][date].map((value) => {
                      const lapse = date === '3M' ? 3 : date === '6M' ? 6 : 12
                      const firstDate = moment(new Date()).subtract(lapse, 'months').format('YYYY-MM-01')
                      functions.push(getLMP(datastructure, token, client, plan, value.value, firstDate, lastDate, date))
                    })
                  })
                })
              } else {
                layers.layers.map((layer) => {
                  let seasons = Object.keys(layer[client])
                  if (layer.name.includes("Saavi's Polygons")) {
                    functions.push(getSaaviLayers(datastructure, token, client, plan, 'summer', false))
                  } else {
                    seasons.map((season) => {
                      layer[client][season].map((value) => {
                        if (layer.name.includes('LMP Polygon Level')) {
                          functions.push(getSaaviLayers(datastructure, token, client, plan, season, true))
                        } else if (layer.name.includes('LMP Node Level')) {
                          functions.push(getSaaviLayersLMP(datastructure, token, client, plan, value.value, season))
                        } else if (layer.name.includes('Congestion Prices Node Level')) {
                          functions.push(
                            getSaaviLayersCongestion(datastructure, token, client, plan, value.value, season),
                          )
                        }
                      })
                    })
                  }
                })
              }
              break

            case 'Infrastructure':
              layers.layers.map((layer) => {
                if (layer.name == 'Powerplants' || layer.name == 'Power Plants') {
                  layer[client].map((value) => {
                    // setPlants([])//es para que en cada recarga o cambio de mapa, ponga las plantas correspondientes al mapa
                    functions.push(getTechnologyLayers(datastructure, token, client, plan, value.value))
                  })
                } else if (layer.name == 'Transmission Lines') {
                  layer[client].map((value) => {
                    functions.push(getTranlineLayers(datastructure, token, client, plan, value.value))
                  })
                } else if (layer.name == 'Market Intelligence') {
                  layer[client].map((value) => {
                    functions.push(getProyectsUnderDevelopLayers(datastructure, token, client, plan, value.value))
                  })
                } else if (layer.name == 'Substations') {
                  layer[client].map((value) => {
                    //setSubstations([])es para que en cada recarga o cambio de mapa, ponga las plantas correspondientes al mapa
                    functions.push(getSubstationsLayers(datastructure, token, client, plan, value.value))
                  })
                }
              })
              break

            case 'Interconnection Capacity':
              layers.layers.map((layer) => {
                if (layer.name == 'Interconnection Capacity ') {
                  let seasons = Object.keys(layer[client])
                  seasons.map((season) => {
                    layer[client][season].map((value) => {
                      functions.push(getInterconnectionLayers(datastructure, token, client, plan, value.value, season))
                    })
                  })
                } else if (layer.name == 'Transmission Lines Thermal Limits') {
                  layer[client].map((value) => {
                    functions.push(getTranlineConnectionLayers(datastructure, token, client, plan, value.value))
                  })
                }
              })
              break

            case 'Protected Areas':
              layers.layers.map((layer) => {
                if (layer.name == 'Ground Cover & Vegetation') {
                  tiles.protected_area.ground_cover_vegetation = []
                } else {
                  layer[client].map((value) => {
                    tiles.protected_area.protected_areas.push(value.label)
                  })
                }
              })
              break

            case 'Flora & Fauna':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  tiles.flor_fauna.priority_regions.push(value.label)
                })
              })
              break

            case 'Social':
              layers.layers.map((layer) => {
                if (layer.name == 'Indigenous Languages') {
                  functions.unshift(getIndigenousLanguagesLayers(datastructure, token, client, plan))
                } else if (layer.name === 'Indigenous Presence') {
                  tiles.social.indigenous_presence = {}
                } else {
                  layer[client].map((value) => {
                    if (layer.name == 'Indigenous Presence CONABIO') {
                      tiles.social.indigenous_presence_conabio.push(value.label)
                    } else {
                      tiles.social.social.push(value.label)
                    }
                  })
                }
              })
              break

            case 'Land Ownership':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  tiles.land_ownership.national_agricultural_registry.push(value.label)
                })
              })
              break

            case 'National Landmarks & Archeology':
              functions.push(getArcheologyLayers(token, client, plan))
              break

            case 'Other infrastructure':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  if (layer.name == 'Pipelines') {
                    if (tiles.oil_gas.pipelines.find((e) => e === value.label) === undefined)
                      tiles.oil_gas.pipelines.push(value.label)
                  }
                  if (layer.name == 'Hydrocarbon Contracts') {
                    if (tiles.oil_gas.hydrocarbon_contracts.find((e) => e === value.label) === undefined)
                      tiles.oil_gas.hydrocarbon_contracts.push(value.label)
                  }
                  if (layer.name == 'Wells and Seeps') {
                    if (tiles.oil_gas.wells_seeps.find((e) => e === value.label) === undefined)
                      tiles.oil_gas.wells_seeps.push(value.label)
                  }
                  if (layer.name == 'Roads') {
                    tiles.oil_gas.roads = []
                  }
                })
              })
              break

            case 'Geology & Hydrology':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  if (layer.name == 'Hydrology Regions') {
                    if (tiles.geology.hydrology_regions.find((e) => e === value.label) === undefined)
                      tiles.geology.hydrology_regions.push(value.label)
                  }
                  if (layer.name == 'Hydrology Basins') {
                    if (tiles.geology.hydrology_basins.find((e) => e === value.label) === undefined)
                      tiles.geology.hydrology_basins.push(value.label)
                  }
                  if (layer.name == 'Hydrology Sub Basins') {
                    if (tiles.geology.hydrology_sub_basins.find((e) => e === value.label) === undefined)
                      tiles.geology.hydrology_sub_basins.push(value.label)
                  }
                  if (layer.name == 'Geology') {
                    tiles.geology.geology = []
                  }
                  if (layer.name == 'Flood Zones') {
                    if (tiles.geology.flood_zones.find((e) => e === value.label) === undefined)
                      tiles.geology.flood_zones.push(value.label)
                  }
                })
              })
              break

            case 'Administrative Division':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  tiles.municipality.adminitrative_division.push(value.label)
                })
              })
              break

            case 'Land Use':
              layers.layers.map((layer) => {
                layer[client].map((value) => {
                  tiles.land_use.land_uses.push(value.label)
                })
              })
              break

            case 'Oil & Gas':
              layers.layers.map((layer) => {
                if (layer.name == 'Sedimentary Basins') {
                  functions.unshift(getOil_Gas(datastructure, token, client, plan, 'basin'))
                }
                layer[client].map((value) => {
                  if (layer.name == 'Pipelines') {
                    if (tiles.oil_gas.pipelines.find((e) => e === value.label) === undefined)
                      tiles.oil_gas.pipelines.push(value.label)
                  }
                  if (layer.name == 'Hydrocarbon Contracts') {
                    if (tiles.oil_gas.hydrocarbon_contracts.find((e) => e === value.label) === undefined)
                      tiles.oil_gas.hydrocarbon_contracts.push(value.label)
                  }
                  if (layer.name == 'Wells and Seeps') {
                    if (tiles.oil_gas.wells_seeps.find((e) => e === value.label) === undefined)
                      tiles.oil_gas.wells_seeps.push(value.label)
                  }
                  if (layer.name == 'Roads') {
                    tiles.oil_gas.roads = []
                  }
                })
              })
              break

            case 'Mining Rights':
              tiles.mining_rights = {}
              break
          }
        })
        functions.unshift(getMapboxLayers(datastructure, token, client, plan, tiles))
        functions.push(getToolLayers())
        // functions.push(getMunicipalityList(datastructure, token, client, plan))

        const response = await Promise.all(functions)
        let layerData = []
        response.map((obj) => {
          if (Array.isArray(obj)) {
            obj.map((layer) => layerData.push(layer))
          } else {
            layerData.push(obj)
          }
        })
        return layerData
      }
    }
  }
}
